import React from 'react'

const CustomSoundInformation = ({ items }) => {
    return (
        <div className="mb-6">
            <div className={"grid grid-cols-1 md:grid-cols-3 border rounded overflow-hidden text-sm text-left"}>
                {items.map((item, index) => (
                    <div
                        key={index}
                        className={"p-3 border-t md:border-t-0 md:border-l"}
                    >
                        <div className="flex justify-between md:block">
                            <div className="font-medium">{item.label}</div>
                            <div className="flex items-center">
                                <div className="text-gray-800">{item.value}</div>
                                {item?.detail}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CustomSoundInformation